module.exports = __webpack_public_path__ + "static/media/step_2.1bbc4291.gif";